
<template>
  <v-container class="white-wrapper" fluid>
    <div class="d-flex flex-column align-center justify-center" style="margin:0 30px;">
      
      <!-- <v-img class="mt-5" ref="nftimg" src="@/assets/img/nft-placeholder.svg" /> -->
      <div class="nft-title" style="max-width: 25rem; margin: 0 auto">

        <div class="nft-btn">
          <!-- 
          <router-link to="/nft" class="back-icon">
            <img class="back-svg" src="@/assets/icon/arrow(back).svg" />
          </router-link>

          <button type="button" class="share">
            <img class="share-svg" src="@/assets/icon/share.svg" />
          </button>
           -->
        </div>

        
        <div class="nft-img">
          <v-img class="mt-5" id="nftimg" name="nftimg"  ref="nftimg" :style="imgHeigth" v-model="nftimgSrc" :src=this.nftimgSrc />
        </div>
        <div class="nft-info" :class="{ invisible:  nftBtnShow }"  >
          <div style="margin-top:30px;"></div>
          <div class="nft_name">KAN</div>

          <div class="selling_info">

            <div class="selling_info-list">
              <!-- 구매가 -->
              <div class="selling-info_title">{{ $t('nft.purchasePrice') }}</div> 
              
              <div class="selling-info_content">
                <div class="nft_point"> <span>0.5</span> ETH</div>
                <div class="nft_price"> ≈ <span >{{ this.nftPrice |comma }}</span> KRW</div>
              </div>
            </div>
          <!-- 
            <div class="selling_info-list">
              <div class="selling-info_title">잔여 수량</div>
              <div class="selling-info_content">
                <span>16</span>개 / <span>20</span>개
              </div>
            </div> 
          -->

          <!-- 
              <div class="selling_info-list">
              <div class="selling-info_title">보유 잔고</div>
              <div class="selling-info_content point">
                <span>0.10809360</span>
                ETH
                <img src="@/assets/icon/swap_2.svg" alt="reset icon" class="reset_icon">
              </div>
            </div> 
          -->

            <div class="selling_info-list">
              <!--구매 수량-->
              <div class="selling-info_title">{{ $t('nft.quantity') }}</div>
              <!--개-->
              <div class="selling-info_content">1{{ $t('nft.qty') }}</div>
            </div>

            </div>
        </div>
        
        <div style="width: 100%" class="px-5"  :class="{ invisible: !nftBtnShow }"  >
          <v-btn
            class="font-weight-bold text-h5"
            style="color: #22224b"
            color="white"
            x-large
            block          
            @click="confirmModal = true"
          >
          <!--등록하기-->
          {{ $t('nft.registration') }}
          </v-btn>
        </div>


      </div>
    </div>   
    <v-dialog v-model="confirmModal" persistent max-width="30rem">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text
          style="
            min-height: 5rem;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
        <!-- 등록하시겠습니까?-->
        {{ $t('nft.regConfirm') }}
        </v-card-text>    
        <v-divider></v-divider>
        <v-card-actions class="pa-0">
          <v-btn
            color="#AFAFAF"
            width="50%"
            text  
            x-large
            class="font-weight-bold"
            @click="confirmModal = false"
          >
          {{ $t('cancel') }}
          <!-- 취소 -->
          </v-btn>
          <v-divider vertical></v-divider>
          <v-btn
            color="primary"
            width="50%"
            text
            x-large
            class="font-weight-bold"
            @click="regNft"
          >
          {{ $t('register') }} 
          <!-- 등록 -->
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

 

    <v-dialog v-model="messageModal" max-width="30rem">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text
          v-html="message"
          style="
            min-height: 5rem;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            width="100%"
            text
            x-large
            @click="messageModal = false"
            class="font-weight-bold"
          >
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<!-- 
<template>
  <div class="nft-cotainer" fluid>
    <div class="nft-title" style="max-width: 25rem; margin: 0 auto">

      <div class="nft-btn">
        <router-link to="/nft" class="back-icon">
          <img class="back-svg" src="@/assets/icon/arrow(back).svg" />
        </router-link>

        <button type="button" class="share">
          <img class="share-svg" src="@/assets/icon/share.svg" />
        </button>
      </div>

      <div class="nft-img">
        <img src="@/assets/img/kan.png" alt="">
      </div>

      <div class="nft-info">
        <div class="state">진행중</div>
        <div class="nft_name">KAN</div>

        <div class="calendar">
          <div class="timer">
            <div class="days timer_shape">
              <span>00</span>
              <span>Days</span>
            </div>
            <span class="timer_icon">:</span>
            <div class="hours timer_shape">
              <span>00</span>
              <span>Hours</span>
            </div>
            <span class="timer_icon">:</span>
            <div class="Min timer_shape">
              <span>00</span>
              <span>Minutes</span>
            </div>
            <span class="timer_icon">:</span>
            <div class="sec timer_shape">
              <span>00</span>
              <span>Seconds</span>
            </div>
          </div>

          <div class="date">
            진행기간 : <span>2022.11.11 14:00 ~ 11.30 14:00</span>
          </div>
        </div>

        <div class="selling_info">

          <div class="selling_info-list">
            <div class="selling-info_title">판매가</div>
            <div class="selling-info_content">
              <div class="nft_point"> <span>0.125</span> ETH</div>
              <div class="nft_price"> ≈ <span>0.125</span> KRW</div>
            </div>
          </div>

          <div class="selling_info-list">
            <div class="selling-info_title">잔여 수량</div>
            <div class="selling-info_content">
              <span>16</span>개 / <span>20</span>개
            </div>
          </div>

          <div class="selling_info-list">
            <div class="selling-info_title">보유 잔고</div>
            <div class="selling-info_content point">
              <span>0.10809360</span>
              ETH
              <img src="@/assets/icon/swap_2.svg" alt="reset icon" class="reset_icon">
            </div>
          </div>

          <div class="selling_info-list">
            <div class="selling-info_title">구매 수량</div>
            <div class="selling-info_content">2개</div>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

--> 
<script>
export default {
  data() {
    return {
      confirmModal: false, 
      messageModal: false,
      message: '' , 
      nftBtnShow : true , 
      nftimgSrc  : require(`@/assets/img/nft-placeholder.svg`)  , 
      nftPrice : 0 , 

    }
  },
  filters:{
  comma(val){
  	return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  },
  computed: {     
    imgHeigth(){
  console.log("imgHeigth ::" , this.nftBtnShow  )
      return ( this.nftBtnShow == true  ) ? {} : {height : '400px'}  ; 
    } , 
    title() {
      const name = this.$route.name ;
      return name.charAt(0).toUpperCase() + name.slice(1)
    },  
    wallet() {
      // console.log("ssssss", this.$store.getters.wallet ) 
      // return this.$store.getters.wallet
      return this.$store.getters.wallet.filter(
                    (i) => i.name === 'ETH'//&& i.name !== 'ETH'
                  )

    },

  },
  created() {
    this.$store.commit('loading', true ) ; 
    //setTimeout(  ,2000)
    this.apiCall()
    
  },
  methods: {
    regNft(){
      this.$router.push('/config/nft');
    },
    apiCall() {
      // this.wallet
      let _params  = {
        action : 'mylist'
      } 

      this.$store
              .dispatch('nft_proc', _params)
              .then((res) => {
                if ( res.data && res.data.status == true ) {                  
                  // this.$refs.nftimg.src = '@/assets/img/kan.png' ;
                  this.nftimgSrc =  require(`@/assets/img/kan.png`)   ; 
                  this.$refs.nftimg.heigth  = '400px';
                  
                  // console.log( "sssssssss : " , this.$refs.nftimg ) ;
                  // alert('d')
                  this.nftBtnShow =false ;
                  let p = (this.wallet[0].price*0.5 )  ; 
                  this.nftPrice = p.toFixed(0) ; 

                  // console.log(  p.toFixed(0) ) ;

                  this.$store.commit('loading', false) ; 
                  
                }else if(res.data && res.data.status == false   ){
              
                  this.$store.commit('loading', false) ;  
                } else if (res.data && res.data.error) throw res.data.error
                else throw res
              })
              .catch((err) => {
                this.$store.commit('loading', false)
                this.$store.dispatch('toast', {
                    toast: true,
                    toast_msg: this.$t('errorServer'),
                    timeout: 3000
                  }) ; 
 
              }) ;

 
        
    }
  }
}
</script>

<style lang="scss" scoped>
.white-wrapper {
  // background: #22224b;
  // background-image: url('~@/assets/img/event-bg.png');
  // background-size: cover;
  // background-position: 0 -50px;
}
.invisible {
    visibility: hidden;
  }
</style>

<style lang="scss" scoped>
  .nft-cotainer {
    padding: 0 16px;
  }

  // 상단 icon
  .nft-btn {
    display: flex;
    justify-content: space-between;
    margin-top: 38px;
  }

  .back-svg {
    width: 23px;
    height: 23px;
  }

  .share-svg {
    width: 26px;
    height: 26px;
  }

  // image
  .nft-img {
    width: 260px;
    height: 400px;
    margin: 0 auto;
  }

  .nft-img>img {
    width: 100%;
  }

  // nft 상세 내용
  .nft-info .state {
    font-size: 14px;
    color: #fff;
    background-color: #4D4D4D;
    width: 55px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    border-radius: 5px;
    margin-top: 32px;
  }

  .nft-info .nft_name {
    font-size: 30px;
    margin-top: 8px;
  }

  .nft-info .calendar {
    text-align: center;
  }

  .nft-info .calendar,
  .selling_info {
    width: 100%;
    border-bottom: 0.5px solid #e0e0e0b0;
  }

  .timer {
    width: 100%;
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }

  .timer_shape {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 65px;
    height: 67px;
    background-color: #EBEBEB;
    border-radius: 10px;
  }

  .timer_shape span:first-child {
    font-size: 21px;
    font-weight: 500;
  }

  .timer_shape span:last-child {
    font-size: 13px;
  }

  .timer_icon {
    font-size: 37px;
    font-weight: 300;
    margin: 0 7px;
  }

  .nft-info .date {
    margin: 14px 0 25px;
  }

  .selling_info {
    margin-top: 25px;
  }

  .selling_info-list {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  .selling-info_title {
    color: #747474;
  }

  .selling-info_content {
    text-align: right;
  }

  .selling-info_content .nft_point {
    font-size: 20px;
  }

  .selling-info_content .nft_price {
    color: #747474;
  }

  .selling-info_content.point {
    display: flex;
  }

  .selling-info_content .reset_icon {
    margin-left: 8px;
    width: 30px;
    height: 30px;
    cursor: pointer;
  }
</style>